<template>
  <div>
    <nav
      id="gnb"
      class="mx-auto d-flex d-lg-none align-items-center p-2 p-lg-4 bg-white position-fixed top-0 left-0  zIndex-20 text-lg-center"
    >
      <div class="btn-logo ml-2 mr-auto mx-lg-auto">
        <b-button
          variant="white"
          class="btn p-0 p-lg-0 border-0"
          @click="$router.push('/').catch((err) => {})"
        >
          <img
            :src="require('@/assets/symbol.svg')"
            alt="마을예술창작소 로고, 메인페이지로 이동"
            class="logo w-100 d-none d-lg-block"
          />
          <img
            :src="require('@/assets/logo-horizonal.svg')"
            alt="마을예술창작소 로고, 메인페이지로 이동"
            class="logo d-lg-none"
          />
        </b-button>
      </div>
      <div class="mt-2 mr-2 mt-lg-4 mx-lg-auto">
        <b-button
          variant="transparant"
          class="btn btn-hbg mx-auto px-0 pb-0 border-0"
          :class="{ 'btn-hbg-active': navToggle }"
          @click="navToggle = !navToggle"
        >
          <!-- <transition name="fade" mode="out-in"> -->
          <i
            class="icon icon-36 icon-hbg"
            v-if="navToggle == false"
            key="collapsed"
          ></i>
          <i
            class="icon icon-36 icon-close"
            v-if="navToggle == true"
            key="opend"
          ></i>
          <!-- </transition> -->
        </b-button>
      </div>
      <transition name="fade" mode="out-in">
        <div
          class="position-fixed bottom-0 mb-4 ml-3 d-none d-lg-block"
          v-if="navToggle == false"
        >
          <a
            role="button"
            href="https://www.facebook.com/maulart"
            target="_blank"
          >
            <i class="icon icon-32 icon-facebook mb-n1 d-inline-block"></i>
          </a>
        </div>
      </transition>
    </nav>
    <transition name="slide-fade">
      <nav
        class="nav position-fixed top-0 zIndex-19 bg-white d-md-none"
        v-show="navToggle == true"
      >
        <ul class="list-unstyled mt-5 px-4 py-5 pb-lg-0 w-100">
          <router-link
            v-for="(item, i) in LinkList"
            :key="i"
            :to="{ path: item.url }"
            class="my-2 my-lg-4 py-1 w-100"
            tag="li"
          >
            <i class="icon icon-21 icon-star-purple mb-n1 mr-n1"></i>
            <span class="text-uppercase text-lg-18">
              {{ item.name }}
            </span>
          </router-link>
          <!-- <li>
            <b-btn
              variant="third text-white"
              class="mb-2"
              pill
              @click="mapToggle = !mapToggle"
              >다양한 마술소 지도 보기
            </b-btn>
          </li> -->
          <hr />
          <li
            class="text-14 mb-2"
            :style="{ pointerEvent: 'none', cusor: 'normal' }"
          >
            다양한 지도로 마술소 보기
          </li>
          <!-- <transition-group name="fade"> -->
          <li
            v-for="(item, i) in mapList"
            :key="'item-' + i"
            class="mb-2 text-left"
          >
            <b-btn variant="link text-third" class="p-0" :href="item.url">
              <div
                class="text-left"
                :style="{ fontSize: '14px', wordBreak: 'keep-all' }"
              >
                {{ item.name }}
              </div>
            </b-btn>
          </li>
          <!-- </transition-group> -->

          <li class="pl-1 mt-3 mt-lg-5 pt-2">
            <a
              role="button"
              href="https://www.facebook.com/maulart"
              target="_blank"
            >
              <i class="icon icon-24 icon-facebook mb-n1 d-inline-block"></i>
              <span class="ml-2">Facebook</span>
            </a>
          </li>
          <li>
            <div class="mt-5" v-if="user !== undefined">
              <span class="text-lg-14 text-grey-light">
                {{ user.email }}로 로그인되었습니다.
              </span>
              <b-button
                variant="grey-lightest"
                pill
                class="mt-2 px-4 d-block"
                @click="logout()"
              >
                <span class="text-lg-12">로그아웃</span>
              </b-button>
            </div>
          </li>
        </ul>
      </nav>
    </transition>
    <div
      class="dim w-100 h-100 vh-100
      position-fixed top-0 left-0 zIndex-12 bg-grey-dim d-md-none"
      @click="navToggle = !navToggle"
      v-show="navToggle == true"
    ></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      LinkList: [
        { name: "소개합니다", url: "/introduce" },
        { name: "웹진 '담다'", url: "/webzine" },
        { name: "갤러리", url: "/gallery" },
        { name: "자료실", url: "/dataroom" },
        { name: "마술소 찾기", url: "/contact" },
      ],
      navToggle: false,
      user: undefined,
      mapToggle: false,
      mapList: [
        {
          name: "모든 사람들에게 열려 있는 공간, 마을예술창작소",
          url:
            "https://www.google.com/maps/d/u/0/viewer?mid=1bynPBgnXIUbmXZbIAC79MNdQ6aF4p8mg&ll=37.59332363451459%2C126.95198451669171&z=10",
        },
        {
          name: "MBTI 유형별 추천 마.술.소",
          url:
            "https://www.google.com/maps/d/u/0/viewer?mid=1P0GtI9WIstjuSlimma2lnRZR_MuY9dlr&ll=37.558714754772176%2C126.90877903106484&z=11",
        },
        {
          name: "한 눈에 보는 마술소 실외공간 지도",
          url:
            "https://www.google.com/maps/d/viewer?hl=ko&mid=12TVI1jH1vsuPJkknzzND8jgM8nbwwfVS&ll=37.562192187993325%2C126.98365945000003&z=11",
        },
        {
          name: "마술소 지하철 여행",
          url:
            "https://www.google.com/maps/d/viewer?mid=1PTrYZfICUVlmjoc6OLdst6WS60tRmEXV&ll=37.562192187993325%2C126.98365945&z=12",
        },
        {
          name: "마술소 템포 지도",
          url:
            "https://www.google.com/maps/d/u/0/viewer?mid=1nxcGBpHHO_LwGvF-FNKjBU5rzQYCDD0g&ll=37.556661912824495%2C126.9543269074737&z=13",
        },
        {
          name: "감각에 따른 마을예술창작소 분류",
          url:
            "https://www.google.com/maps/d/u/0/viewer?mid=14cvWAITLxanvHneBMzbxLskXJgJV05Fx&ll=37.555219202728004%2C126.98365945000003&z=12",
        },
        {
          name: "마술소 한눈에 일러스트 지도",
          url:
            "https://firebasestorage.googleapis.com/v0/b/art-masulso.appspot.com/o/%E1%84%86%E1%85%A1%E1%84%8B%E1%85%B3%E1%86%AF%E1%84%8B%E1%85%A8%E1%84%89%E1%85%AE%E1%86%AF%E1%84%8E%E1%85%A1%E1%86%BC%E1%84%8C%E1%85%A1%E1%86%A8%E1%84%89%E1%85%A9_%E1%84%8B%E1%85%B5%E1%86%AF%E1%84%85%E1%85%A5%E1%84%89%E1%85%B3%E1%84%90%E1%85%B3%E1%84%8C%E1%85%B5%E1%84%83%E1%85%A9.png?alt=media&token=7ff573ad-92c3-4f6d-a3d7-ca16d412e217",
        },
      ],
    };
  },
  computed: {
    logined() {
      return this.$store.state.user;
    },
  },
  watch: {
    $route() {
      this.navToggle = false;
    },
    logined(user) {
      if (this.$store.state.user !== undefined) {
        return (this.user = user);
      }
    },
  },
  methods: {
    logout() {
      this.$firebase
        .auth()
        .signOut()
        .then(() => {
          alert("로그아웃되었습니다.");
          window.location.replace("/");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#gnb {
  width: 7rem;
  height: 100vh;
  @media all and (max-width: 1280px) {
    width: 100%;
    height: auto;
    .logo {
      width: auto !important;
      height: 40px !important;
    }
  }
}
.btn-logo {
  width: 100% !important;
  height: 60px !important;
  button {
    width: 100% !important;
    height: 100% !important;
  }
  @media all and (max-width: 1280px) {
    width: 100% !important;
    text-align: center;
    button {
      width: 10rem !important;
    }
  }
}
.logo {
  cursor: pointer;
  height: auto !important;
}

// nav
.nav {
  height: 100%;
  left: 7rem !important;
  border-radius: 0 1.25rem 1.25rem 0;
  @media all and (max-width: 1280px) {
    width: 100% !important;
    height: inherit !important;
    left: 0 !important;
    border-radius: 0 0 1.25rem 1.25rem;
  }
}
.nav li {
  cursor: pointer;
  i.icon {
    display: none;
  }
}
.router-link-active {
  font-weight: 700 !important;
  color: #7a2a90;
  i.icon {
    display: inline-block !important;
  }
}

.dim {
  left: 7rem !important;
  width: calc(100% - 7rem) !important;
  @media all and (max-width: 1280px) {
    width: 100% !important;
    left: 0 !important;
  }
}

// transition
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.4s ease;
}
.slide-fade-leave-active {
  transition: all 0.4s;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(-100px);
  @media all and (max-width: 1280px) {
    transform: translateY(-100px);
  }
  opacity: 0;
}
</style>
